/*----------------------------------------*\
  SITE LEXSEARCH BUNDLE
\*----------------------------------------*/

import api from 'components/Api';
import { bindDefinitions } from 'helpers/ui';
import mtm from 'components/Mtm';

class SiteLexsearch {
  constructor() {
    this.setupCollapseItems();
    this.setupModals();
    this.setupFeedbackBox();

    bindDefinitions();
  }

  setupCollapseItems() {
    const collapseItems = [...document.querySelectorAll('[data-behaviour="collapse"]')];

    collapseItems.forEach(collapseItem => {
      new Styleguide.Collapse(collapseItem);
    });
  }

  setupModals() {
    // login modal
    const loginModal = document.querySelector('#login-modal');
    if (loginModal) {
      new Styleguide.Modal(loginModal, {
        onShow(modal) {
          mtm.trackModal(modal.id);
        },
      });
    }

    // switch account modal
    const switchAccountModal = document.querySelector('#switch-account-modal');
    if (switchAccountModal) {
      new Styleguide.Modal(switchAccountModal, {
        onShow(modal) {
          mtm.trackModal(modal.id);
        },
      });
    }

    // video modals
    const searchVideoModals = document.getElementsByClassName('search-video-modal');
    if (searchVideoModals) {
      for (let i = 0; i < searchVideoModals.length; i++) {
        new Styleguide.Modal(searchVideoModals[i], {
          onShow(modal) {
            const iframe = modal.querySelector('iframe');
            iframe.dataset.originalSrc = iframe.src;
            iframe.src += '&autoplay=1';
          },
          onHide(modal) {
            const iframe = modal.querySelector('iframe');
            iframe.src = iframe.dataset.originalSrc;
          },
        });
      }
    }
  }

  setupFeedbackBox() {
    const feedbackDocumentNodes = [
      ...document.querySelectorAll('[data-feedback-search-document-id][data-feedback-helpful]'),
    ];

    feedbackDocumentNodes.forEach(feedbackNode => {
      feedbackNode.addEventListener('click', event => {
        event.preventDefault();
        this.sendFeedback(
          feedbackNode.dataset.feedbackSearchDocumentId,
          feedbackNode.dataset.feedbackHelpful,
          'document',
        );
      });
    });
    const feedbackPhaseNodes = [...document.querySelectorAll('[data-feedback-search-phase-id][data-feedback-helpful]')];
    feedbackPhaseNodes.forEach(feedbackNode => {
      feedbackNode.addEventListener('click', event => {
        event.preventDefault();
        this.sendFeedback(
          feedbackNode.dataset.feedbackSearchPhaseId,
          feedbackNode.dataset.feedbackHelpful,
          'phase',
        );
      });
    });
  }

  sendFeedback(id, helpful, type) {
    helpful = parseInt(helpful);
    [...document.querySelectorAll('.feedback-buttons')].forEach(feedbackButtonsNode => {
      feedbackButtonsNode.hide();
    });
    [...document.querySelectorAll('.feedback-thank-you')].forEach(feedbackThankYouNode => {
      feedbackThankYouNode.show();
    });

    // mtm
    const helpfulText = helpful === 1 ? 'yes' : 'no';
    mtm.trackFeedback(helpfulText);
    const params = {
      helpful,
    };
    params[`search_${type}_id`] = id;
    api.post(
      `/api/search_${type}_feedbacks`,
      params,
    );

    // Matomo
    const _mtm = window._mtm = window._mtm || [];
    _mtm.push({
      event: 'content_feedback',
      feedback: helpfulText,
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SiteLexsearch();
});
